<template>
  <div class="contents-section-wrap">
    <v-container>
      <v-row
        class="black--text"
      >
        <!-- <v-col class="mt-2 my-sm-6 my-md-12 text-center"> -->
        <v-col class="pt-12 px-0 text-center text-h7 text-sm-h5 font-weight-bold mb-2 mb-sm-6 mb-md-12">
          헬퍼에는 간병 전문가들이 등록되어 있습니다.
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="4"
          sm="4"
          md="4"
          lg="4"
          class="pl-3 pr-0 px-sm-3"
        >
          <v-select
            v-model="selectedRegion"
            :items="regions"
            label="시/도"
            item-text="short_name"
            :item-value="(item) => item"
            append-icon="expand_more"
            outlined
            background-color="#FFFFFF"
            style="margin-bottom: -42px;"
            @input="onChangeRegion"
          />
        </v-col>
        <v-col
          cols="4"
          sm="4"
          md="4"
          lg="4"
          class="px-2  px-sm-3"
        >
          <v-select
            v-model="selectedCity"
            :items="cities"
            label="시/군/구"
            item-text="short_name"
            :item-value="(item) => item"
            append-icon="expand_more"
            outlined
            background-color="#FFFFFF"
            style="margin-bottom: -42px;"
          />
        </v-col>
        <v-col
          cols="4"
          sm="4"
          md="4"
          lg="2"
          class="pl-0 pr-3  px-sm-3"
        >
          <v-select
            v-model="selectedGender"
            :items="genders"
            label="성별"
            item-text="value"
            item-value="id"
            append-icon="expand_more"
            outlined
            background-color="#FFFFFF"
            style="margin-bottom: -42px;"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="2"
        >
          <v-btn
            x-large
            depressed
            color="#2C2C2C"
            class="white--text"
            style="width: 100%; height: 56px;"
            @click="findCaregivers"
          >
            간병인 현황 보기
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="item, k in caregivers"
          :key="`profileCard-${k}`"
          cols="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
        >
          <ProfileCard v-model="caregivers[k]" />
          <!-- <ProfileCard v-model="" /> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="my-16 text-center"
        >
          <v-btn
            v-show="hasNextPage"
            outlined
            class="white black--text"
            style="border: 1px solid #E5E5E5 !important; border-radius: 5px !important;"
            width="260px"
            height="60px"
            @click="getNextRecordSet"
          >
            간병인 더보기
            <v-icon
              right
              large
              style="font-size: 30px;"
            >
              add
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProfileCard from '../caregiver/ProfileCard'
import { getAddressList } from '../../models/addressFinder'
import caregiverApi from '../caregiver/api/caregiver'

export default {
  components: {
    ProfileCard
  },
  data() {
    return {
      selectedRegion: {
        idx: null
      },
      selectedCity: {
        idx: null
      },
      selectedGender: '',
      hasNextPage: false,
      page: 1,
      limit: 6,
      filters: '',
      caregivers: [],
      regions: [],
      cities: [],
      genders: [
        { id: '', value: '전체' },
        { id: 'male', value: '남' },
        { id: 'female', value: '여' }
      ]
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      await this.getRegions()
      await this.getCaregivers()
    },
    async getCaregivers() {
      const result = await caregiverApi.getCaregivers(this.page, this.limit, this.filters)
      this.caregivers = [...this.caregivers, ...result.items]
      this.hasNextPage = (this.page < result.pagination.total_page)
    },
    async findCaregivers() {
      const filters = []
      this.page = 1
      this.filters = ''
      this.caregivers = []

      if (this.selectedGender) {
        filters.push(`gender=${this.selectedGender}`)
      }
      if (this.selectedRegion.idx && this.selectedRegion.area !== '전체') {
        filters.push(`location=${this.selectedRegion.idx}`)
      }
      if (this.selectedCity.idx && this.selectedCity.area !== '전체') {
        filters.push(`detail_location=${this.selectedCity.idx}`)
      }

      this.filters = filters.join('|')
      console.log(this.filters)
      await this.getCaregivers()
    },
    async getNextRecordSet() {
      this.page += 1
      await this.getCaregivers()
    },
    async getRegions() {
      this.regions = await getAddressList()
    },
    async onChangeRegion() {
      this.cities = await getAddressList(this.selectedRegion.idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.contents-section-wrap {
  background-color: #F9F9F9;
}
</style>
